import React from 'react'
import Form from './Form/Form';

const InspirationBlock = () => {
  return (
    <div className="crtSearchInspirationBlock">
      <Form hasBtn />
    </div>
  )
}

export default InspirationBlock
